import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { TimeService } from '../time.service';

import { DateTime } from 'luxon';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
declare var google: any;

@Component({
  selector: 'app-driver-path',
  templateUrl: './driver-path.component.html',
  styleUrls: ['./driver-path.component.scss']
})
export class DriverPathComponent implements OnInit {

  map;
  from: any = {
    date: '',
    time: ''

  }
  to: any = {
    date: '',
    time: ''

  }
  pathData: any ={};
  coordinates = [];
  flightPath: any;
  simMode = false;
  appMode = false;
  gpsMode = false;
  simLength = 0;
  appLength = 0;
  gpsLength = 0;
  lat = 0;
  lng = 0;
  submit = false;
  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public parentData: any,
              private timeService: TimeService, private http: HttpService, private snackBar: SnackbarService) { }

  ngOnInit() {
    this.initMap();
  }
  initMap(lat = 12.960691, lng = 77.580116) {
    const marker = {
      latitude: lat,
      longitude: lng
    };
    const mapProp = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
      // styles: this.mapStyle,
    };
    this.map = new google.maps.Map(document.getElementById('pathMap'), mapProp);
    google.maps.event.addListener(this.map, 'click', function(event) {
    });

  }
  setDateTime(from) {
    if (from.date && from.time) {
      const t1: any = this.timeService.getDateFromTime(from.time, 'hh:mm a');
      const epoch: any = DateTime.fromJSDate(from.date).plus({hours: t1.c.hour, minutes: t1.c.minute});
      from.date_time = epoch.ts;
    }
  }
  fetchPath() {
    const url = 'driver/path?driver_id=' + this.parentData._id + '&from=' + this.from.date_time + '&to=' + this.to.date_time;
    this.http.get(url).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.submit = true;
          this.pathData = {};
          const result = data.data;
          this.pathData = result;
          this.simLength = (data.data.sim) ? data.data.sim.length : 0;
          this.appLength = (data.data.app) ? data.data.app.length : 0;
          this.gpsLength = (data.data.gps) ? data.data.gps.length : 0;
          if (this.appLength) {
            this.appMode = true;
          } else if (this.simLength) {
            this.simMode = true;
          } else if (this.gpsLength) {
            this.gpsMode = true;
          }
          this.drawPath();

        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  drawPath() {
    if (this.flightPath) {
      this.flightPath.setMap(null); // Clear polyline
      this.coordinates = [];
    }
    const bounds = new google.maps.LatLngBounds();
    if (this.appMode) {
      this.pathData.app.forEach(element => {
        const latLng = {
          lat: 0.0,
          lng: 0.0
        };
        latLng.lat = element.location[1];
        latLng.lng =  element.location[0];
        this.coordinates.push(latLng);
        bounds.extend(latLng);
      });
    } else if (this.simMode) {
      this.pathData.sim.forEach(element => {
        const latLng = {
          lat: 0.0,
          lng: 0.0
        };
        latLng.lat = element.location[1];
        latLng.lng =  element.location[0];
        this.coordinates.push(latLng);
        bounds.extend(latLng);
      });
    } else if (this.gpsMode) {
      this.pathData.gps.forEach(element => {
        const latLng = {
          lat: 12.91739,
          lng: 77.8988169444444
        };
        latLng.lat = element.location[1];
        latLng.lng =  element.location[0];
        this.coordinates.push(latLng);
        bounds.extend(latLng);
      });
    }
    this.flightPath = new google.maps.Polyline({
      path: this.coordinates,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2
    });

    this.flightPath.setMap(this.map);
    this.map.fitBounds(bounds);
}
  closeDialog() {
    this.dialog.closeAll();
  }
}
